import { ISimpleTab } from '~/src/dash/components/tabs/common';

export interface IBiddersConfig {
  tabs: ISimpleTab[];
}

export const biddersConfig = {
  tabs: [
    { key: 'All', label: 'All', value: 0 },
    { key: 'Groups', label: 'Groups', value: 1 },
    { key: 'Demand Source Settings', label: 'Demand Source Settings', value: 2 },
  ],
} as IBiddersConfig;
